import { render, staticRenderFns } from "./classificationIndexes.vue?vue&type=template&id=1573f6c1&scoped=true"
import script from "./classificationIndexes.vue?vue&type=script&lang=js"
export * from "./classificationIndexes.vue?vue&type=script&lang=js"
import style0 from "./classificationIndexes.vue?vue&type=style&index=0&id=1573f6c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1573f6c1",
  null
  
)

export default component.exports